import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../helpers/language';
import ReCAPTCHA from 'react-google-recaptcha';
import { useRef, useState } from 'react';
import { validateContactForm } from '../../utils/validations';
import { sendContact } from '../../hooks/useSendContact';
import { useFeedback } from '../../hooks/useFeedback';
import { setLoading } from '../ui/uiSlice';
import { useDispatch } from 'react-redux';
import { showError, showSuccess } from '../../utils/notify';

const ContactSection = () => {
  const { language } = useLanguage();
  const dispatch = useDispatch();
  const t = translations[language].contactSection;
  const recaptchaRef = useRef<any>(null);
  const siteKey: any = process.env.REACT_APP_reCAPTCHA_KEY_SITE;
  const { loading, success, error, warning } = useFeedback();
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  //const [uloading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});


  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(setLoading(true));
    setStatus('idle');

    const errors = validateContactForm(formData, t.errors);
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      dispatch(setLoading(false));
      return;
    }

    setFormErrors({});

    const token = await recaptchaRef.current?.executeAsync();
    recaptchaRef.current?.reset();

    const params = {
      Tipo: 'CONTACTO',
      Nombre: formData.name,
      CorreoElectronico: formData.email,
      Mensaje: formData.message
    };

    const send = await sendContact(params, language);

    if (send?.Result) {
      dispatch(setLoading(false));
      showSuccess(t.success);
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: '',
      })
    }
    else {
      dispatch(setLoading(false));
      showError(t.error);
    }
  };

  return (
    <>
      <section id="contact" className="section-image" data-aos="fade-up">
        <div className="content-image-about">
          <h1 className="content-about-title">
            {t.header.split(" ")[0]} <span className="text-span-10">{t.header.split(" ")[1]}</span>
          </h1>
        </div>
      </section>

      <section className="section-form-content" data-aos="fade-up">
        <div className="section-contact-left">
          <h1 className="contact-title">{t.subtitle}</h1>
          <form className="form" onSubmit={handleSubmit}>
            <div className="input-div">
              <label htmlFor="name" className="field-label">Name</label>
              <input
                className="input-form icon-user-black w-input"
                type="text"
                id="name"
                placeholder={t.fields.name}
                onChange={handleChange}
                value={formData.name}
              />
              {formErrors.name && <small className="error-text">{formErrors.name}</small>}
            </div>

            <div className="input-div">
              <label htmlFor="email" className="field-label">Email</label>
              <input
                className="input-form icon-mail-black w-input"
                type="email"
                id="email"
                placeholder={t.fields.email}
                onChange={handleChange}
                value={formData.email}
              />
              {formErrors.email && <small className="error-text">{formErrors.email}</small>}
            </div>

            <div className="input-div">
              <label htmlFor="subject" className="field-label">Subject</label>
              <input
                className="input-form icon-subject-black w-input"
                type="text"
                id="subject"
                placeholder={t.fields.subject}
                onChange={handleChange}
                value={formData.subject}
              />
              {formErrors.subject && <small className="error-text">{formErrors.subject}</small>}
            </div>

            <div className="input-div">
              <label htmlFor="message" className="field-label">Message</label>
              <textarea
                className="input-form input-area w-input"
                id="message"
                placeholder={t.fields.message}
                onChange={handleChange}
                value={formData.message}
              />
              {formErrors.message && <small className="error-text">{formErrors.message}</small>}
            </div>

            <div className="w-form-formrecaptcha recaptcha-custom">
              {siteKey && (
                <ReCAPTCHA
                  sitekey={siteKey}
                  ref={recaptchaRef}
                  onChange={(token: any) => {
                    console.log('Captcha token:', token);
                  }}
                />
              )}
            </div>

            <input type="submit" className="button-form w-button" value={t.button} />
          </form>

          <div className="w-form-done"><div>{t.success}</div></div>
          <div className="w-form-fail"><div>{t.error}</div></div>
        </div>

        <div className="section-contact-rigth">
          <div className="div-block-5">
            <h1 className="heading-3">Contact Info</h1>
            <img src="/images/line-blue.svg" alt="" className="image-2" />
	    <div className="div-block">
              <a href="mailto:helpdesk@castletechllc.com"><img src="/images/boton_ticket.png" alt="" /></a>
            </div>
            <div className="div-block">
              <img src="/images/mail-white.svg" alt="" className="image-3" />
              <div className="text-block">{t.info.email}</div>
            </div>
            <div className="div-block-2">
              <img src="/images/maps-white.svg" alt="" className="image-4" />
              <div className="text-block-2">{t.info.address}</div>
            </div>
            <div className="div-block-3">
              <img src="/images/phone-white.svg" alt="" className="image-5" />
              <div className="text-block-3">{t.info.phone}</div>
            </div>
            <div className="map w-widget w-widget-map">
              <div className="map w-widget w-widget-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2466.7611930236094!2d-82.20223263379653!3d29.030986020511303!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e7d7c256f51d69%3A0x9a74258416f4e7f1!2s4778%20SW%20131st%20Pl%2C%20Ocala%2C%20FL%2034473%2C%20EE.%20UU.!5e0!3m2!1ses!2sgt!4v1748367267104!5m2!1ses!2sgt"
                  width="100%"
                  height="340"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="CASTLETECH LLC">
                </iframe>
              </div>
            </div>
          </div>

          <div className="content-imagen">
            <img src="/images/facebook-white.svg" alt="Facebook" className="image-6" />
            <img src="/images/instagram-white.svg" alt="Instagram" className="image-7" />
            <img src="/images/twitter-white.svg" alt="Twitter" className="image-8" />
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactSection;
